import * as Combobox from '@givebutter/primitives/combobox';

const TicketStatusOptions = () => (
    <>
        <Combobox.Item value="checked_in">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Checked in</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="not_checked_in">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Not checked in</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="revoked">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Revoked</Combobox.ItemText>
        </Combobox.Item>
    </>
);

export { TicketStatusOptions };
